import React from 'react'
import styled from 'styled-components'
import { Book } from '../../../../data/book/data-types'
import { useDialog } from '../../dialog/hook'
import BookDialog from '../../custom-dialogs/book'
import ColoredDialogBackdrop from '../../custom-dialogs/colored-dialog-backdrop'

type SearchItemProps = {
  book: Book
  onClick?: () => void
}

const SearchItem: React.FunctionComponent<SearchItemProps> = ({ book, onClick }) => {
    const { setComponent } = useDialog()

    const description = book.synopsys?.length || 0 > 150 ? book.synopsys!.slice(0, 150) + "..." : book.synopsys

    return (
        <Container onClick={() => {
            if(onClick) {
                onClick()
            } 
            setComponent(<BookDialog book={book} needsUpdate={true} />, <ColoredDialogBackdrop bg={book.bg_color}/>)
        }}>
            <Image src={book.image || ""} alt={book.title} />
            <Data>
                <Title>{book.title}</Title>
                <Description>{description}</Description>
            </Data>
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 10px;

    width: 100%;

    border-bottom: 1px solid ${p => p.theme.colors.lightGray};
    padding: 10px;

    cursor: pointer;
`

const Image = styled.img`
    border-radius: 10px;
    width: 60px;
`

const Data = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
    grid-row-gap: 10px;

    overflow-x: hidden;
`

const Title = styled.div`
    font-weight: bold;
`

const Description = styled.div`
    color: ${p => p.theme.colors.serviceGray};
    font-size: 14px;
`

export default SearchItem